import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Select, InputLabel, FormControl, MenuItem } from "@mui/material";

const SelectController = ({ name, label, defaultValue, children }) => {
  const { control } = useFormContext();
  const labelId = `${name}-label`;
  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Controller
        render={({ field, fieldState: { invalid, error } }) => (
          <Select
            error={error ? true : false}
            labelId={labelId}
            label={label}
            {...field}
          >
            <MenuItem value="">Select</MenuItem>
            <MenuItem value="3">03 parcelas</MenuItem>
            <MenuItem value="6">06 parcelas</MenuItem>
            <MenuItem value="9">09 parcelas</MenuItem>
            <MenuItem value="12">12 parcelas</MenuItem>
            <MenuItem value="16">16 parcelas</MenuItem>
            <MenuItem value="18">18 parcelas</MenuItem>
          </Select>
        )}
        name={name}
        control={control}
        defaultValue={defaultValue}
      />
    </FormControl>
  );
};
export default SelectController;
